import Vue from 'vue'
import Http from '../api/Http.js'

const baseURL = 'https://api.ezcont.com.br/api/' //(process.env.NODE_ENV === 'production') ? 'https://api.ezcont.com.br/api/' : 'http://localhost:8989/api'

Vue.use({
  install(Vue) {
    const http = new Http({
      baseURL,
    })

    Vue.prototype.$http = http
    Vue.$http = http
  },
})
export default (_) => { }
